class SavingCalculator extends HTMLElement {
  constructor() {
    super();
    this.currencySymbol = this.getCurrencySymbol();
    this.setCostValues();
  }

  getCurrencySymbol() {
    const locale = document.documentElement.lang || 'gb';
    const currencyData = {
      'de': '€',
      'gb': '£',
      'fr': '€',
    };
    return currencyData[locale] || '£';
  }

  setCostValues() {
    const locale = document.documentElement.lang || 'gb';
    if (locale === 'de') {
      this.averageCottonCost = 0.63;
      this.scrummiCost = 0.29;
    } else {
      this.averageCottonCost = 0.55;
      this.scrummiCost = 0.20;
    }
  }

  calculate() {
    const towelsPerClient = parseFloat(this.perClient.value) || 0;
    const clientsPerMonth = parseFloat(this.clients.value) || 0;
    const totalTowelsUsed = towelsPerClient * clientsPerMonth;

    const currentCost = this.averageCottonCost * totalTowelsUsed;
    const newCost = totalTowelsUsed * this.scrummiCost;

    const savings = currentCost - newCost;

    // Update UI
    if (this.price) this.price.innerHTML = this.dataset.price.replace(/{{.*}}/g, savings.toFixed(2));

    if (this.currencySymbol === '€') {
      if (this.currentCost) this.currentCost.innerHTML = `${currentCost.toFixed(2)}${this.currencySymbol}`;
      if (this.newCost) this.newCost.innerHTML = `${newCost.toFixed(2)}${this.currencySymbol}`;
    } else {
      if (this.currentCost) this.currentCost.innerHTML = `${this.currencySymbol}${currentCost.toFixed(2)}`;
      if (this.newCost) this.newCost.innerHTML = `${this.currencySymbol}${newCost.toFixed(2)}`;
    }
  }

  handleClientsInputEvent(event) {
    this.calculate();
    let target = event.target;
    let newPoint = (target.value / target.getAttribute('max')) * 100;
    this.rangeValueSpan.innerHTML = target.value;
    this.rangeValueSpan.style.left = `calc(${newPoint}% + (${1 - newPoint * 0.5}px))`;
  }

  connectedCallback() {
    this.price = this.querySelector('.js-calculator-price');
    this.rangeValueSpan = this.querySelector('.js-output');
    this.currentCost = this.querySelector('.js-calculator-current-price');
    this.newCost = this.querySelector('.js-calculator-new-price');

    this.clients = this.querySelector('.js-calculator-clients');
    if (this.clients) {
      this.clients.addEventListener('input', this.handleClientsInputEvent.bind(this));
    }

    this.perClient = this.querySelector('.js-calculator-per-client');
    if (this.perClient) {
      this.perClient.addEventListener('input', this.calculate.bind(this));
    }

    // Trigger initial calculation
    this.handleClientsInputEvent({ target: this.clients });
    this.calculate();
  }
}

customElements.define('saving-calculator', SavingCalculator);

